.studentDisplay {
	display: flex;
	align-items: center;
	gap: 0.75rem;
	align-items: center;
	width: 100%;
}

.studentSelector {
	font-weight: 400;
	font-size: 1.25rem;
}

.studentButton:global(.MuiButton-root) {
	height: 32px;
	width: 95px;
}

.studentSelectorLayout {
	display: flex;
	min-height: 75px;
	align-items: center;
	padding: 20px 3%;
	border-bottom: 0.5px solid #cacaca;
	gap: 3px;
}

.studentIconButton {
	border: 1.11px solid #e5e7eb;
	width: 40px;
	height: 40px;
	border-radius: 10px;
}
